<template>
    <div class="ecaps-sidenav" id="ecapsSideNav">
                <!-- Side Menu Area -->
                <div class="side-menu-area">
                    <!-- Sidebar Menu -->
                    <nav>
                        <ul class="sidebar-menu" data-widget="tree">
                            <template v-if="listPermisos.includes('inicio.index')">
                                <li @click="activate(0)" :class="{ active : active_el == 0 }">
                                    <router-link :to="'/'" replace><i class="fas fa-tachometer-alt"></i> <span>Inicio</span></router-link>
                                </li>
                            </template>

                            <template v-if="listPermisos.includes('seguro.index') || listPermisos.includes('coberturadeducible.index')">
                                <li class="treeview">
                                    <a href="#"><i class="fas fa-lock"></i><span>Seguros</span>
                                        <i class="fa fa-angle-right"></i></a>
                                    <ul class="treeview-menu">

                                        <template v-if="listPermisos.includes('cliente.index')">
                                            <li @click="activate(1)" :class="{ active : active_el == 1 }"><router-link :to="'/seguros'"><i class="fas fa-lock"></i> <span>Seguros</span></router-link></li>
                                        </template>

                                         <template v-if="listPermisos.includes('coberturadeducible.index')">
                                            <li @click="activate(14)" :class="{ active : active_el == 14 }"><router-link :to="'/coberturadeducibles'"><i class="fas fa-money-bill-wave"></i> <span>Deducible|Cobertura</span></router-link></li>
                                        </template>
                                    </ul>
                                </li>
                            </template>


                            <template v-if="listPermisos.includes('categoria.index') || listPermisos.includes('marca.index')
                                            || listPermisos.includes('tipovehiculo.index') || listPermisos.includes('tipouso.index') || listPermisos.includes('modelo.index')
                                            || listPermisos.includes('clasificacion.index')">
                                <li class="treeview">
                                    <a href="#"><i class="fas fa-car-alt"></i><span>Vehiculos</span>
                                        <i class="fa fa-angle-right"></i></a>
                                    <ul class="treeview-menu">
                                        <template v-if="listPermisos.includes('categoria.index')">
                                            <li @click="activate(2)" :class="{ active : active_el == 2 }"><router-link :to="'/categorias'"><i class="fas fa-th-large"></i> <span>Categorias</span></router-link></li>
                                        </template>
                                        <template v-if="listPermisos.includes('marca.index')">
                                            <li @click="activate(3)" :class="{ active : active_el == 3 }"><router-link :to="'/marcas'"><i class="fas fa-tags"></i> <span>Marcas</span></router-link></li>
                                        </template>
                                         <template v-if="listPermisos.includes('tipovehiculo.index')">
                                            <li @click="activate(4)" :class="{ active : active_el == 4 }"><router-link :to="'/tipovehiculos'"><i class="fas fa-tags"></i> <span>Tipo de Vehiculos</span></router-link></li>
                                        </template>
                                        <template v-if="listPermisos.includes('tipouso.index')">
                                            <li @click="activate(5)" :class="{ active : active_el == 5 }"><router-link :to="'/tipousos'"><i class="fas fa-tags"></i> <span>Tipo de Usos</span></router-link></li>
                                        </template>
                                        <template v-if="listPermisos.includes('modelo.index')">
                                            <li @click="activate(6)" :class="{ active : active_el == 6 }"><router-link :to="'/modelos'"><i class="fas fa-car-side"></i> <span>Modelos</span></router-link></li>
                                        </template>
                                        <template v-if="listPermisos.includes('modelo_anio.index')">
                                            <li @click="activate(18)" :class="{ active : active_el == 18 }"><router-link :to="'/modelo-anio'"><i class="fas fa-tags"></i> <span>Año del mercado</span></router-link></li>
                                        </template>
                                        <template v-if="listPermisos.includes('modelo_valor_mercado.index')">
                                            <li @click="activate(19)" :class="{ active : active_el == 19 }"><router-link :to="'/valor-mercado'"><i class="fas fa-tags"></i> <span>Valor de Mercado</span></router-link></li>
                                        </template>
                                        <template v-if="listPermisos.includes('modelo_version.index')">
                                            <li @click="activate(20)" :class="{ active : active_el == 20 }"><router-link :to="'/versiones'"><i class="fas fa-tags"></i> <span>Versiones</span></router-link></li>
                                        </template>
                                        <template v-if="listPermisos.includes('clasificacion.index')">
                                            <li @click="activate(15)" :class="{ active : active_el == 15 }"><router-link :to="'/clasificaciones'"><i class="fas fa-tags"></i> <span>Clasificación</span></router-link></li>
                                        </template>
                                    </ul>
                                </li>
                            </template>

                            <template v-if="listPermisos.includes('cliente.index') || listPermisos.includes('cotizacion.index') || listPermisos.includes('referencia.index')">
                                <li class="treeview">
                                    <a href="#"><i class="fas fa-file-invoice"></i><span>Cotización</span>
                                        <i class="fa fa-angle-right"></i></a>
                                    <ul class="treeview-menu">

                                        <template v-if="listPermisos.includes('cliente.index')">
                                            <li @click="activate(7)" :class="{ active : active_el == 7 }"><router-link :to="'/clientes'"><i class="fas fa-address-book"></i> <span>Cliente</span></router-link></li>
                                        </template>
                                        <template v-if="listPermisos.includes('cliente_data.index')">
                                            <li @click="activate(16)" :class="{ active : active_el == 16 }"><router-link :to="'/tratar-datos-clientes'"><i class="fas fa-address-book"></i> <span>Importacion de datos</span></router-link></li>
                                        </template>
                                        <a type="button" @click="abrilModalIm()"><i class="fas fa-file-excel"></i> <span>importacion de renovación</span></a>

                                        <template v-if="listPermisos.includes('referencia.index')">
                                            <li @click="activate(14)" :class="{ active : active_el == 14 }"><router-link :to="'/referencias'"><i class="fas fa-asterisk"></i> <span>Referencias</span></router-link></li>
                                        </template>

                                         <template v-if="listPermisos.includes('ramo.index')">
                                            <li @click="activate(18)" :class="{ active : active_el == 18 }"><router-link :to="'/ramos'"><i class="fas fa-asterisk"></i> <span>Ramos</span></router-link></li>
                                        </template>

                                         <template v-if="listPermisos.includes('actividadeconomica.index')">
                                            <li @click="activate(15)" :class="{ active : active_el == 15 }"><router-link :to="'/actividadeconomicas'"><i class="fas fa-chart-line"></i> <span>Actividad Economica</span></router-link></li>
                                        </template>

                                         <template v-if="listPermisos.includes('cotizacion.index')">
                                            <li @click="activate(8)" :class="{ active : active_el == 8 }"><router-link :to="'/cotizaciones'"><i class="fas fa-file-signature"></i> <span>Cotización</span></router-link></li>
                                        </template>
                                    </ul>
                                </li>
                            </template>

                            <template v-if="listPermisos.includes('usuario.index') || listPermisos.includes('rol.index') || listPermisos.includes('permisos.index') || listPermisos.includes('pagos.index')">
                                <li class="treeview">
                                    <a href="#"><i class="fas fa-user-cog"></i><span>Usuarios</span>
                                        <i class="fa fa-angle-right"></i></a>
                                    <ul class="treeview-menu">
                                        <template v-if="listPermisos.includes('usuario.index')">
                                            <li @click="activate(9)" :class="{ active : active_el == 9 }"><router-link :to="'/usuarios'"><i class="fas fa-user-shield"></i> <span>Usuarios</span></router-link></li>
                                        </template>
                                        <template v-if="listPermisos.includes('rol.index')">
                                            <li @click="activate(10)" :class="{ active : active_el == 10 }"><router-link :to="'/roles'"><i class="fas fa-user-check"></i> <span>Roles</span></router-link></li>
                                        </template>
                                        <template v-if="listPermisos.includes('permisos.index')">
                                            <li @click="activate(11)" :class="{ active : active_el == 11 }"><router-link :to="'/permisos'"><i class="fas fa-key"></i> <span>Permisos</span></router-link></li>
                                        </template>
                                        <template v-if="listPermisos.includes('pagos.index')">
                                            <li @click="activate(12)" :class="{ active : active_el == 12 }"><router-link :to="'/pago'"><i class="fas fa-file-invoice-dollar"></i><span>Pagos</span></router-link></li>
                                        </template>
                                        <template v-if="listPermisos.includes('documento.index')">
                                            <li @click="activate(13)" :class="{ active : active_el == 13 }"><router-link :to="'/documentos'"><i class="fas fa-id-card"></i><span>Documento</span></router-link></li>
                                        </template>
                                    </ul>
                                </li>
                            </template >

                            <template v-if="listPermisos.includes('sueldo_basico.index')">
                                <li class="treeview">
                                    <a href="#"><i class="fas fa-cog"></i><span>Configuración</span>
                                        <i class="fa fa-angle-right"></i></a>
                                    <ul class="treeview-menu">
                                        <template v-if="listPermisos.includes('usuario.index')">
                                            <li @click="activate(17)" :class="{ active : active_el == 17 }">
                                                <router-link :to="'/sueldo-basico'"><i class="fas fa-money-bill"></i>
                                                <span>Sueldo básico</span>
                                                </router-link>
                                            </li>
                                        </template>
                                    </ul>
                                </li>
                            </template >

                               <!-- Inicio Sección de Reportes -->
                        <template v-if="listPermisos.includes('reporte.index')">
                            <li class="treeview">
                                <a href="#">
                                    <i class="fas fa-chart-line"></i><span> Reportes</span>
                                    <i class="fa fa-angle-right"></i>
                                </a>
                                <ul class="treeview-menu">
                                    <!-- Sub-item: Reporte de Ventas -->
                                    <template v-if="listPermisos.includes('reporte.ventas')">
                                        <li @click="activate(30)" :class="{ active : active_el == 30 }">
                                            <router-link :to="'/reportes-ventas'">
                                                <i class="fas fa-file-invoice-dollar"></i> <span>Renovación Proxima</span>
                                            </router-link>
                                        </li>
                                        <!--li @click="activate(30)" :class="{ active : active_el == 30 }">
                                            <router-link :to="'/reportes/ventas'">
                                                <i class="fas fa-file-invoice-dollar"></i> <span>Ventas</span>
                                            </router-link>
                                        </li-->
                                    </template>

                                    <!-- Sub-item: Reporte de Clientes -->
                                    <template v-if="listPermisos.includes('vehiculo.buscar')">
                                        <li @click="activate(30)" :class="{ active : active_el == 30 }">
                                            <router-link :to="'/buscar-vehiculo'">
                                                <i class="fas fa-car"></i> <span>Buscar Vehículo</span>
                                            </router-link>
                                        </li>
                                    </template>

                                    <template v-if="listPermisos.includes('cedula.buscar')">
                                        <li @click="activate(30)" :class="{ active : active_el == 30 }">
                                            <router-link :to="'/buscar-cedula'">
                                                <i class="fas fa-id-card"></i> <span>Consultar Cédula</span>
                                            </router-link>
                                        </li>
                                    </template>

                                </ul>
                            </li>
                        </template>
<!-- Fin Sección de Reportes -->

                            <!-- <li class="treeview">
                                <a href="#"><i class="fas fa-people-carry"></i><span>Empleados</span>
                                    <i class="fa fa-angle-right"></i></a>
                                <ul class="treeview-menu">
                                    <li @click="activate(9)" :class="{ active : active_el == 9 }"><router-link :to="'/empleados'"><i class="fas fa-users"></i> <span>Empleados</span></router-link></li>
                                    <li @click="activate(10)" :class="{ active : active_el == 10 }"><router-link :to="'/pagos'"><i class="fas fa-file-invoice-dollar"></i><span>Pagos</span></router-link></li>
                                </ul>
                            </li> -->

                        </ul>
                    </nav>
                </div>
            </div>


</template>

<script>
import {alertasM} from '../../util.js';
export default {
    props: ['listPermisos','usuario'],
    mixins: [alertasM],
    data(){
            return{
             active_el:0,

            }
        },
    methods:{
        activate:function(el){
            this.active_el = el;
        },

        abrilModalIm(){
            this.$emit("importExcelA", true);

        }


  },

}
</script>

<style>

</style>
